import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const GrabAccountLinkLazy = lazyLoader(
  () => import('./GrabAccountLink' /* webpackChunkName: "grab-account-link" */),
);

const GrabAccountLink = () => {
  return (
    <Suspense fallback={null}>
      <GrabAccountLinkLazy />
    </Suspense>
  );
};

export default GrabAccountLink;
